module.exports = __webpack_public_path__ + "static/img/20017 (4).7cc45d0.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20017 (4).webp
// module id = Rtjr
// module chunks = 14